<template>
  <div class="flex flex-col items-center relative">
    <AudioComponent></AudioComponent>
    <!-- <p
      class="text-xl lg:text-5xl pt-20 lg:pt-32 text-center text-[#061B44] font-semibold"
    >
      {{ $t("Who_Can_Benefit_from_Audio_Transcript_Generator") }}
    </p>
    <div
      class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-8 items-start justify-center pt-20 lg:pt-32 w-[90%] pb-10"
    >
      <div
        v-for="item in firstSection"
        :key="item.id"
        class="flex flex-col items-center justify-start space-y-4"
      >
        <img :src="item.id" alt="" class="h-44" />
        <p
          class="text-[#061B44] text-xl font-bold text-center"
          v-html="item.title"
        ></p>
        <p class="font-medium text-center text-sm">
          {{ item.description }}
        </p>
      </div>
    </div>-->
  </div> 
</template>

<script setup lang="ts">
import AudioComponent from "../components/audio_component.vue";
import { useHead } from "@vueuse/head";

useHead({
  title: "Audio Transcription - Subtitles Tech",
});
</script>
